import React, { useState, useEffect, useContext, useCallback } from "react";
import { IconButton, Tooltip, Badge } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import { makeStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
  btnNone: {
    color: theme.palette.action.active,
  },
  btnHasAppt: {
    color: theme.palette.primary.main,
  },
}));

const AppointmentButton = ({ ticket, onClick, open }) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const { getSetting } = useContext(SettingsContext);

  const [appointment, setAppointment] = useState(null);

  const apptEnabled = getSetting("appointmentsEnabled") === "true";

  const fetchAppointment = useCallback(async () => {
    if (!ticket?.id || !apptEnabled) return;
    if (ticket.status === "closed" || ticket.status === "resolved") return;
    try {
      const { data } = await api.get(`/appointments/ticket/${ticket.id}`);
      setAppointment(data);
    } catch (err) {
      if (err?.response?.status === 404) setAppointment(null);
    }
  }, [ticket?.id, ticket?.status, apptEnabled]);

  useEffect(() => {
    fetchAppointment();
  }, [fetchAppointment, open]);

  // Only show for admin/user profile and non-closed tickets
  if (!apptEnabled) return null;
  if (ticket.status === "closed" || ticket.status === "resolved") return null;
  if (user.profile !== "admin" && user.profile !== "user" && !user.isSuperAdmin) return null;

  const tooltipTitle = appointment
    ? `Cita: ${format(new Date(appointment.scheduledAt), "dd/MM HH:mm")}`
    : "Agendar cita";

  return (
    <Tooltip title={tooltipTitle} arrow>
      <IconButton
        size="small"
        className={appointment ? classes.btnHasAppt : classes.btnNone}
        onClick={onClick}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!appointment}
        >
          <EventIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default AppointmentButton;
